import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { CalendarDto, CalendarService } from '../../Services/API';

export const useAddAgencyCalendar = (
  config?: UseMutationOptions<
    string,
    Error,
    { agencyId: string; brandCode: string; body: CalendarDto },
    unknown
  >
) => {
  return useMutation(async params => {
    params.brandCode = params.brandCode ?? '';
    return await CalendarService.calendarControllerAddCalendar(params);
  }, config);
};
